import React, { Component } from 'react';
import WOW from 'wowjs';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min';
import './App.css';
import SiteData from './SiteData';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: localStorage.siteLang
    };
    window.$("html").attr("lang", this.state.lang);
    window.$("html").attr("dir", this.state.lang === "en" ? "ltr" : "rtl");
    window.$("body").addClass(this.state.lang === "en" ? "ltr" : "rtl");

    window.$("title").text(SiteData.name[this.state.lang]);
    window.$("#description").attr("content", SiteData.description[this.state.lang]);
    window.$("meta[name='keywords']").attr("content", SiteData.keywords);

    window.$("meta[itemprop='name']").attr("content", SiteData.name[this.state.lang]);
    window.$("meta[itemprop='description']").attr("content", SiteData.description[this.state.lang]);
    
    window.$("meta[name='twitter:title']").attr("content", SiteData.name[this.state.lang]);
    window.$("meta[name='twitter:description']").attr("content", SiteData.description[this.state.lang]);
    window.$("meta[name='twitter:site']").attr("content", SiteData.twitterUser);
    window.$("meta[name='twitter:creator']").attr("content", SiteData.twitterUser);
    
    window.$("meta[property='og:title']").attr("content", SiteData.name[this.state.lang]);
    window.$("meta[property='og:site_name']").attr("content", SiteData.name[this.state.lang]);
    window.$("meta[property='og:description']").attr("content", SiteData.description[this.state.lang]);
    window.$("meta[property='og:url']").attr("content", SiteData.siteUrl);
  }
  toggleLang() {
    if (this.state.lang === "en") localStorage.siteLang = "ar";
    else localStorage.siteLang = "en";
    window.location.reload();
  }
  runComponent() {
    window.$.backstretch(SiteData.siteBackgroundUrls, {duration: 3000, fade: 750});
    window.$(window).on("scroll", function(e) {
      if (window.$(window).scrollTop() >= 300) {
        window.$(".App-header").addClass("is-fixed");
      } else {
        window.$(".App-header").removeClass("is-fixed");
      }
    })
    window.progressively.init()
    new WOW.WOW().init()
    window.$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href^="#_"]').click(function(event) {
      if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
          var target = window.$(this.hash);
          target = target.length ? target : window.$('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            let headerSpace = 80;
            if (this.hash === "#cover") headerSpace = 0;
            event.preventDefault();
            window.$('html, body').animate({
                scrollTop: target.offset().top - headerSpace
            }, 1000);
          }
      }
    });
    var initPhotoSwipeFromDOM = function(gallerySelector) {
        var parseThumbnailElements = function(el) {
            var thumbElements = el.childNodes,numNodes = thumbElements.length,items = [],figureEl,linkEl,size,item;
            for(var i = 0; i < numNodes; i++) {
                figureEl = thumbElements[i];
                if(figureEl.nodeType !== 1) continue;
                linkEl = figureEl.children[0];
                size = linkEl.getAttribute('data-size').split('x');
                item = {src: linkEl.getAttribute('href'),w: parseInt(size[0], 10),h: parseInt(size[1], 10)};
                if(figureEl.children.length > 1) item.title = figureEl.children[1].innerHTML; 
                if(linkEl.children.length > 0) item.msrc = linkEl.children[0].getAttribute('src');
                item.el = figureEl;
                items.push(item);
            }
            return items;
        };
        var closest = function closest(el, fn) {return el && ( fn(el) ? el : closest(el.parentNode, fn) );};
        var onThumbnailsClick = function(e) {
            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;
            var eTarget = e.target || e.srcElement;
            var clickedListItem = closest(eTarget, function(el) {return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');});
            if(!clickedListItem) return;
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length, nodeIndex = 0, index;
            for (var i = 0; i < numChildNodes; i++) {
                if(childNodes[i].nodeType !== 1) continue;
                if(childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }
            if(index >= 0) openPhotoSwipe( index, clickedGallery );
            return false;
        };
        var photoswipeParseHash = function() {
            var hash = window.location.hash.substring(1),
            params = {};
            if(hash.length < 5) return params;
            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if(!vars[i]) continue;
                var pair = vars[i].split('=');  
                if(pair.length < 2) continue;
                params[pair[0]] = pair[1];
            }
            if(params.gid) params.gid = parseInt(params.gid, 10);
            return params;
        };
        var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0], gallery, options, items;
            items = parseThumbnailElements(galleryElement);
            options = {
                history: !1,
                loop: !1,
                timeToIdle: 0,
                timeToIdleOutside: 0,
                spacing: 0,
                tapToClose: !0,
                tapToToggleControls: !1,
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),
                getThumbBoundsFn: function(index) {
                    var thumbnail = items[index].el.getElementsByTagName('img')[0],
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();
                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                }
            };
            if(fromURL) {
                if(options.galleryPIDs) {
                    for(var j = 0; j < items.length; j++) {
                        if(items[j].pid === index) {
                            options.index = j;
                            break;
                        }
                    }
                } else options.index = parseInt(index, 10) - 1;
            } else options.index = parseInt(index, 10);
            if( isNaN(options.index) ) return;
            if(disableAnimation) options.showAnimationDuration = 0;
            gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.listen("beforeChange", function() {
                var currentIndex = gallery.getCurrentIndex();
                if (currentIndex === gallery.options.getNumItemsFn() - 1) window.$(".pswp__button--arrow--right").hide();
                else window.$(".pswp__button--arrow--right").show();
                if (currentIndex === 0) window.$(".pswp__button--arrow--left").hide();
                else window.$(".pswp__button--arrow--left").show();
            })
            gallery.init();
        };
        var galleryElements = document.querySelectorAll( gallerySelector );
        for(var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i+1);
            galleryElements[i].onclick = onThumbnailsClick;
        }
        var hashData = photoswipeParseHash();
        if(hashData.pid && hashData.gid) openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    };
    initPhotoSwipeFromDOM('.App-gallery-container');
  }
  async componentDidMount() {
    this.runComponent();
  }
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="App-header-container">
            <div className="App-header-logo">
                <a href={SiteData.siteUrl} title={SiteData.name[this.state.lang]}><img alt={SiteData.name[this.state.lang]} src={SiteData.headerLogouUrl}/> </a>
            </div>
            <nav className="App-header-nav">
              <ul className="App-header-nav-left">
                {SiteData.headerMenus.map((menu, index) =>
                  <li key={index} className="App-header-nav-item">
                    <a className="App-header-nav-link anchor-scroll" href={menu.url} title={menu.title[this.state.lang]}>{menu.title[this.state.lang]}</a>
                  </li>
                )}
                <li className="App-header-nav-item">
                  <a className="App-header-nav-link" onClick={this.toggleLang.bind(this)} title={this.state.lang === "en" ? "عربي" : "English"}>{this.state.lang === "en" ? "عربي" : "English"}</a>
                </li>
              </ul>
              <ul className="App-header-nav-right">
                {SiteData.social.map((social, index) =>
                  <li key={index} className="App-header-nav-item">
                    <a className="App-header-nav-link" href={social.url} title={social.title[this.state.lang]} target="_blank"><i className={social.icon}></i></a>
                  </li>
                )}
              </ul>
              <a className="App-header-reservation anchor-scroll" href={SiteData.makeReservationBtn.url} title={SiteData.makeReservationBtn.title[this.state.lang]}>{SiteData.makeReservationBtn.title[this.state.lang]}</a>
            </nav>
          </div>
          <div className="App-header-background"></div>
        </header>
        <main className="App-main">
          <section className="section App-cover" id="cover">
            <div className="App-cover-content row expanded align-center align-middle text-center">
              <div className="column">
                <h1 style={{ backgroundImage: "url(" + SiteData.coverContent.imageUrl + ")"}}>{SiteData.coverContent.name[this.state.lang]}</h1>
                {SiteData.coverContent.subtitleLine && SiteData.coverContent.subtitleLine[this.state.lang] ? <p className="white-space-pre">{SiteData.coverContent.subtitleLine[this.state.lang]}</p> : ""}
                {SiteData.coverContent.address ? <div className="App-cover-address">
                  <p className="white-space-pre">{SiteData.coverContent.address[this.state.lang]}</p>
                </div> : ""}
                <div className="App-cover-lang"><a onClick={this.toggleLang.bind(this)} title={this.state.lang === "en" ? "عربي" : "English"}>{this.state.lang === "en" ? "عربي" : "English"}</a></div>
                <div className="App-cover-reservation">
                  <a className="anchor-scroll" href={SiteData.makeReservationBtn.url} title={SiteData.makeReservationBtn.title[this.state.lang]}>{SiteData.makeReservationBtn.title[this.state.lang]}</a>
                </div>
              </div>
            </div>
            <div className="App-cover-arrow align-center align-middle text-center">
              <a href="#introduction" className="anchor-scroll"><i className="fas fa-chevron-down fa-2x"></i></a>
            </div>
          </section>
          <section className="section App-introduction ltr-important" id="introduction">
            <div className="wow fadeIn">
              <div className="row align-middle align-center">
                <div className="column small-10 large-5 xlarge-4 text-center large-text-left">
                    {SiteData.introductionContent.name[this.state.lang] ? <h3>{SiteData.introductionContent.name[this.state.lang]}</h3> : ""}
                    {SiteData.introductionContent.subtitleLine[this.state.lang] ? <h2>{SiteData.introductionContent.subtitleLine[this.state.lang]}</h2> : ""}
                </div>
                <div className="column small-10 large-5 xlarge-4 text-center large-text-left color-black">
                    {SiteData.introductionContent.description.map((description, index) =>
                      <p key={index}>{description[this.state.lang]}</p>
                    )}
                </div>
              </div>
            </div>
          </section>
          <section className="wow fadeIn section App-cover-break" style={{ backgroundImage: "url(" + SiteData.firstBreakImageUrl + ")", backgroundPosition: "center center"}}></section>
          <section className="section App-menus" id="menus">
            <div className="wow fadeIn">
              <div className="row"><div className="column text-center"><h2>{SiteData.menusContent.title[this.state.lang]}</h2></div></div>
              <div className="row"><div className="column">
                <div className="App-menus-navigation js-flickity" data-flickity-options={'{ "asNavFor": ".App-menus-content", "contain": true, "pageDots": false, "prevNextButtons": false, "rightToLeft": ' + (this.state.lang === 'en' ? 'false' : 'true') + ' }'}>
                  {SiteData.menusContent.menus.map((menu, index) => <div key={index} className="App-menus-navigation-item"><span>{menu.title[this.state.lang]}</span></div>)}
                </div>
              </div></div>
              <div className="row"><div className="column">
                <div className="App-menus-content js-flickity" data-flickity-options={'{ "sync": ".App-menus-navigation", "pageDots": false, "adaptiveHeight": true, "prevNextButtons": false, "rightToLeft": ' + (this.state.lang === 'en' ? 'false' : 'true') + ' }'}>
                  {SiteData.menusContent.menus.map((menu, index) =>
                    <div key={index} className="App-menus-section"><div className="row">
                      {menu.dishes.map((dish, dindex) =>
                        <div key={dindex} className={dish.extra ? "column small-12 text-center medium-text-left margin-bottom-1-25" : "column small-12 large-6"}>
                        {dish.extra ? <span className="App-menus-title">{dish.title[this.state.lang]}</span> : ""}
                        {dish.extra ? 
                        <div className="row">
                          {dish.extras.map((extra, eindex) =>
                            <div key={eindex} className="column small-12 large-6">
                              <div className="App-menus-item | row">
                                <div className="App-menus-detail | column small-12 medium-9 text-center medium-text-left"><span className="App-menus-description">  {extra.title[this.state.lang]}</span> {extra.cal && extra.cal[this.state.lang] ? <bdi className="App-menus-description">{"(" + extra.cal[this.state.lang] + " cal)"}</bdi> : ""}</div>
                                <div className="App-menus-price | column small-12 medium-3 text-center medium-text-right">{extra.price && extra.price[this.state.lang] ? extra.price[this.state.lang] : " "}</div>
                              </div>
                            </div>
                          )}
                        </div> : 
                          <div className="App-menus-item | row">
                            <div className="App-menus-detail | column small-12 medium-9 text-center medium-text-left">
                              <span className="App-menus-title">{dish.title[this.state.lang] } </span>
                              {dish.cal && dish.cal[this.state.lang] ? <bdi className="App-menus-description">{"(" + dish.cal[this.state.lang] + " cal)"}</bdi> : ""}
                              {dish.description && dish.description[this.state.lang] ? <div className="App-menus-description"><p>{dish.description[this.state.lang]}</p></div> : ""}
                            </div>
                            <div className="App-menus-price | column small-12 medium-3 text-center medium-text-right">{dish.price && dish.price[this.state.lang] ? dish.price[this.state.lang] : " "}</div>
                          </div>}
                        </div>
                      )}
                    </div></div>
                  )}
                </div>
              </div></div>
              {SiteData.menusContent.footnotes ? <div className="row color-black"><div className="column text-center App-menus-footnotes"><p>{SiteData.menusContent.footnotes[this.state.lang]}</p></div></div> : ""}
            </div>
          </section>
          <section className="section App-gallery" id="gallery">
            <div className="wow fadeIn"><div className="row expanded collapse"><div className="column"><div className="App-gallery-container">
              {SiteData.galleryContent.map((img, index) =>
                <figure key={index} className="App-gallery-item progressive">
                  <a href={img.url} itemProp="contentUrl" data-size={img.size}>
                    <img alt={img.alt[this.state.lang]} className="progressive__img progressive--not-loaded" data-progressive={img.url} src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"/>
                  </a>
                </figure>
              )}
            </div></div></div></div>
          </section>
          <section className="section App-contact" id="contact">
            <div className="wow fadeIn">
              <div className="row expanded collapse align-middle align-center">
                <div className="App-contact-info | column small-12 large-6 small-order-2 large-order-1 text-center">
                  {SiteData.contactContent.name && SiteData.contactContent.name[this.state.lang] ? <h3>{SiteData.contactContent.name[this.state.lang]}</h3> : ""}
                  {SiteData.contactContent.address ? <p className="white-space-pre color-black">{SiteData.contactContent.address[this.state.lang]}</p> : ""}
                  <p className="ltr-important">
                    {SiteData.contactContent.phone ? <a className="color-black" href={"tel:" + SiteData.contactContent.phone.number}>{SiteData.contactContent.phone.text}</a> : ""}
                    <br />
                    {SiteData.contactContent.email ? <a className="color-black" href={"mailto:" + SiteData.contactContent.email}>{SiteData.contactContent.email}</a> : ""}
                  </p>
                  <h4>{SiteData.contactContent.openingHours.title[this.state.lang]}</h4>
                  {SiteData.contactContent.openingHours.description[this.state.lang] ? <p className="white-space-pre color-black">{SiteData.contactContent.openingHours.description[this.state.lang]}</p> : ""}
                  <ul>
                    {SiteData.social.map((social, index) =>
                      <li key={index} className="App-header-nav-item">
                        <a className="App-header-nav-link color-black" href={social.url} title={social.title[this.state.lang]} target="_blank"><i className={social.icon}></i></a>
                      </li>
                    )}
                  </ul>
                  <br />
                  {SiteData.linkToImage.map((linkToImage, index) =>
                    <p key={index}><a className="" href={"#" + linkToImage.id}>{linkToImage.title[this.state.lang]}</a></p>
                  )}
                </div>
                <div className="App-contact-map | column small-12 large-6 small-order-1 large-order-2" style={{backgroundImage: "url(" + SiteData.contactContent.mapImageUrl + ")"}}>
                  <a className="App-contact-icon" href={SiteData.contactContent.mapUrl} target="_blank"> </a>
                </div>
              </div>
            </div>
          </section>
          <section className="wow fadeIn section App-cover-break" style={{ backgroundImage: "url(" + SiteData.secondBreakImageUrl + ")", backgroundPosition: "center center"}}></section>
        </main>
        <footer className="App-footer ltr-important">
          <div className="App-footer-logo | row align-center">
            <div className="column"><a style={{ backgroundImage: "url(" + SiteData.footerContent.company.imageUrl + ")"}} href={SiteData.footerContent.company.url} title={SiteData.footerContent.company.title[this.state.lang]} rel="noopener">{SiteData.footerContent.company.title[this.state.lang]}</a></div>
          </div>
          <div className="App-footer-restaurants | row align-center">
            <div className="column medium-10 large-6 xlarge-5">
              <div className="row medium-unstack">
                {SiteData.footerContent.businesses.map((business, index) =>
                  <div key={index} className="column">
                    <h3>{business.title[this.state.lang]}</h3>
                    <ul>
                      {business.branches.map((branch, bindex) =>
                        <li key={bindex}><a href={branch.url} target="_blank" title={branch.title[this.state.lang]} rel="noopener">{branch.title[this.state.lang]}</a></li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="App-footer-disclaimer | row align-center">
            <div className="column small-12 medium-10 large-8 xlarge-6">
              <p className="no-font"> 
                {SiteData.footerContent.disclaimer.rights && SiteData.footerContent.disclaimer.rights[this.state.lang] ? SiteData.footerContent.disclaimer.rights[this.state.lang] : ""}
                {SiteData.footerContent.disclaimer.privacyPolicy && SiteData.footerContent.disclaimer.privacyPolicy.title[this.state.lang] ? <a href={SiteData.footerContent.disclaimer.privacyPolicy.url} target="_blank" title={SiteData.footerContent.disclaimer.privacyPolicy.title[this.state.lang]} rel="noopener"> {SiteData.footerContent.disclaimer.privacyPolicy.title[this.state.lang]} </a> : ""}
              </p>
              {SiteData.footerContent.disclaimer.description && SiteData.footerContent.disclaimer.description[this.state.lang] ? <p className="no-font">{SiteData.footerContent.disclaimer.description[this.state.lang]}</p> : ""}
            </div>
          </div>
        </footer>
        <div id="photoswipe" className="pswp" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="pswp__bg"></div>
          <div className="pswp__scroll-wrap">
            <div className="pswp__container"><div className="pswp__item"></div><div className="pswp__item"></div><div className="pswp__item"></div></div>
            <div className="pswp__ui pswp__ui--hidden">
              <div className="pswp__top-bar">
                <div className="pswp__counter"></div>
                <button className="pswp__button pswp__button--close" title="Close (Esc)"></button>
                <button className="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                <div className="pswp__preloader"><div className="pswp__preloader__icn"><div className="pswp__preloader__cut"><div className="pswp__preloader__donut"></div></div></div></div>
              </div>
              <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div className="pswp__share-tooltip"> </div></div>
              <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
              <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
              <div className="pswp__caption"><div className="pswp__caption__center"></div></div>
            </div>
          </div>
        </div>
        {SiteData.linkToImage.map((linkToImage, index) =>
          <a key={index} href="#_" className="overlay" id={linkToImage.id}><img src={linkToImage.url} alt="Fullscreen"/></a>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js